import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { IDomainCalculation } from '../../base/types';
import './ResultCards.scss';
import ResultCardsItem from './ResultCardsItem';

export interface IProps {
  domains: IDomainCalculation[];
  skeletonClass: string;
}

const ResultCard: React.FC<IProps> = ({ domains, skeletonClass }) => {
  const { t } = useTranslation();

  const renderResultCards = (domain: IDomainCalculation, index: number) => (
    <ResultCardsItem key={`gauge${index}`} {...domain} skeletonClass={skeletonClass} index={index} />
  );
  return (
    <div className="result-cards">
      <h2 className="result-cards-title">{t('postreg:Evaluation.ResultCardsTitle')}</h2>
      <div className="result-cards-container row">{domains.map(renderResultCards)}</div>
    </div>
  );
};

export default ResultCard;
